<template>
  <div class="error-modal" @click.esc="close">
    <div class="error-modal-body">
      <div class="error-img">
        <img src="@/assets/icon/tick.png" alt="" />
      </div>
      <div class="error-error text-center">
        <p>Шилжүүлэг амжилттай хийгдлээ</p>
        <span>{{ amountStr }} бонус оноо шилжлээ</span>
        <div v-if="!hideBarimt">
          <div class="ebarimt">
            <qrcode v-bind:value="qrData" :options="{ width: 120 }"></qrcode>
            <div class="item">
              <div class="item-child">
                Сугалааны дугаар: <b>{{ lottery }}</b>
              </div>
              <div class="item-child">
                Бүртгүүлэх дүн: <b>{{ feeAmount }}</b>
              </div>
            </div>
          </div>
          <div class="email-success" v-if="sentEmail === 0">
            Таны {{ email }} имэйл рүү НӨАТ-н баримт амжилттай илгээгдлээ.
          </div>
          <div class="email-error" v-else-if="sentEmail === 1">
            <div v-if="email">
              Ибаримын мэдээллийг имэйлээр илгээхэд алдаа гарлаа.
            </div>
            <div v-else>
              Та
              <router-link tag="a" v-bind:to="url" exact>энд</router-link> дарж
              имэйлээ бүртгүүлнэ үү.
            </div>
          </div>
        </div>
        <div class="title">
          <button @click.esc="close">x</button>
        </div>
      </div>

      <div class="error-close">
        <img src="@/assets/icon/close.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.url = "/user-edit";
    } else {
      this.url = "/profile";
    }
  },
  props: [
    "amountStr",
    "cardId",
    "receiver",
    "sentEmail",
    "lottery",
    "qrData",
    "feeAmount",
    "email",
    "billId",
    "hideBarimt",
  ],
  data() {
    return {
      url: "",
    };
  },
  methods: {
    close() {
      this.$emit("hideSuccessMessage");
    },
  },
};
</script>
<style scoped>
.ebarimt-error {
  color: red;
  margin-top: 20px;
}
.ebarimt {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item-child {
  width: 50%;
  text-align: left;
}
.email-error {
  padding-top: 10px;
  color: red;
}
.email-success {
  padding-top: 10px;
  color: green;
}
.error-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.error-modal-body {
  position: absolute;
  top: 80px;
  width: 600px;
  height: 380px;
  border: 1px solid #a2d7a2;
  border-radius: 5px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body div p {
  margin: 0;
  font-size: 18px;
  margin-bottom: 6px;
}
.error-modal-body span {
  display: block;
  margin-bottom: 10px;
}
.error-modal-body .error-img {
  position: absolute;
  top: -15px;
  left: 280px;
}
.error-modal-body .error-img img {
  width: 32px;
  height: 32px;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body img {
  width: 100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 0;
    width: 80%;
    height: 380px;
  }
  .error-modal-body .error-img {
    left: 130px;
  }
  .item-child {
    width: 100%;
  }
  .error-modal-body div p {
    font-size: 16px;
  }
}
.boxes2 {
  width: 100%;
  margin: 0;
}
.boxes2 h2 {
  width: 100%;
  text-align: left;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
  color: #939393;
}
.boxes2 b {
  text-align: right;
  float: right;
  color: #1660ab;
}

.title button {
  top: 0px;
  right: 10px;
  font-size: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #939393;
}
</style>
